export enum AccountStateStatus {
  Completed = 'completed',
  Current = 'current',
  Disabled = 'disabled',
  Pending = 'pending'
}

export enum AccountStateButtonAction {
  RegisterPersonal = 'register-personal',
  RegisterFinancialLife = 'register-financial-life',
  RegisterDocuments = 'register-documents'
}

export enum AccountStateChipType {
  Positive = 'positive',
  Information = 'information',
  Alert = 'alert',
  Negative = 'negative'
}

export interface AccountStateStep {
  icon?: number;
  status: AccountStateStatus;
  title: string;
  description: string;
  chipLabel?: string;
  chipType?: AccountStateChipType;
}

export interface AccountStateButton {
  label: string;
  action: AccountStateButtonAction;
}

export interface AccountStateResponse {
  title: string;
  description: string;
  button: AccountStateButton;
  steps: AccountStateStep[];
}
